import { PropsWithChildren } from 'react';

export interface BoxContainerProps {}

export function BoxContainer({ children }: PropsWithChildren<BoxContainerProps>) {
  return <div className='flex flex-wrap gap-3'>{children}</div>;
}
